export const domValues = {
  PROJECT_GROUP_ACCORDION_OFFSET: 170,
};

export const dateFormats = {
  FULL_DATE: 'd LLL, yyyy',
  LIST_FORMAT: 'd LLL yyyy',
  DATE_PICKER_UNFOCUSED: 'd MMMM yyyy',
  DATE_PICKER_FOCUSED: 'yyyy-MM-dd',
};
export const timeFormats = {
  FULL_TIME: 'HH:mm:ss',
  MESSAGE_TIME: 'HH:mm',
  AMPM_TIME: 'hh:mm aa',
};

export const fieldValidationMessages = {
  REQUIRED: 'This field is required',
  EMAIL: 'Must be a valid email',
  TYPE_NUM: 'Should be number',
  INTEGER: 'Should be an integer number',
  MAX_CHAR: (max: number) => `Max ${max} characters`,
  MIN_CHAR: (min: number) => `Minimum ${min} characters`,
  MAX_NUM: (max: number) => `Max ${max}`,
  MIN_NUM: (min: number) => `Minimum ${min}`,
  MIN_PASSWORD: 'Password is too short',
  WEAK_PASSWORD: 'Password is too weak',
  REQUIRED_PASSWORD: 'Enter a password',
  REQUIRED_EMAIL: 'Enter an email',
  PASSWORD_REPEAT: 'Repeat the password',
  PASSWORD_MATCH: "Those passwords didn't match, try again",
  CURRENT_PASSWORD: 'Enter current password',
  LENGTH: (length: number) => `Must be exactly ${length} characters`,
};

export const formValidations = {
  MAX_TITLE_LENGTH: 255,
  MAX_SHORT_TEXT_LENGTH: 128,
};

export const MIN_LAYOUT_WIDTH = 1220;
export const breakpoints = {
  mobileScreen: 768,
};

export const SOUNDCLOUD_PROVIDER_ID = 'SoundCloud';
export const TUNECORE_PROVIDER_ID = 'TuneCore';
export const CONNEX_PROVIDER_ID = 'Connex';

export const SCROLLBAR_WIDTH_PX = 10;

export const OUTSIDE_SCROLL_ELEMENT_ID = 'outside-scroll-container';
